import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-xs tracking-widest uppercase text-amber-700 font-semibold">
            Testimonials
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold text-stone-800 mt-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Testimonials of Transformation
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          {/* Card */}
          <div className="bg-white rounded-2xl p-10 border border-stone-100">
            {/* Stars */}
            <div className="flex items-center gap-1 mb-6">
              {Array.from({ length: t.rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-500 text-sm" />
              ))}
            </div>
            {/* Quote */}
            <p
              className="text-xl text-stone-700 leading-relaxed mb-8 italic"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              &ldquo;{t.text}&rdquo;
            </p>
            {/* Author + Nav */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-14 h-14 rounded-full object-cover object-top"
                />
                <div>
                  <p className="font-bold text-stone-800 text-sm">{t.name}</p>
                  <p className="text-xs text-stone-400">{t.role}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() =>
                    setActive((prev) =>
                      prev === 0 ? testimonials.length - 1 : prev - 1
                    )
                  }
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-stone-200 text-stone-600 hover:bg-stone-100 transition-all cursor-pointer"
                >
                  <i className="ri-arrow-left-line" />
                </button>
                <button
                  onClick={() =>
                    setActive((prev) =>
                      prev === testimonials.length - 1 ? 0 : prev + 1
                    )
                  }
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-stone-800 text-white hover:bg-amber-700 transition-all cursor-pointer"
                >
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  i === active ? "bg-amber-700 w-6" : "bg-stone-300"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
